import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedFeatureApi } from '@/features/api/hooks/shared-feature/useSharedFeatureApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetFeatures = () => {
  const api = useSharedFeatureApi();
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: [API_CACHE_KEYS.FEATURES],
    queryFn: () => api.getFeatures(),
    enabled: isAuthenticated,
    ...DATA_INIT_CACHING
  });
};
